import React, { useRef, useState } from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { ScanQRCodeStyled } from "./styled";
import QRScannerView from "../QRScannerView";
import { decodeQrFromImageFile } from "utils/functions/scanQR";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Icons } from "components";

const ScanQRCode = ({
  label = "Scan QR Warranty",
  uploadLabel,
  theme_standard,
  enableUpload,
  onSuccessScan,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  const { t } = useTranslation(["common"]);

  const [_isOpen, setIsOpen] = useState(false);
  const fileInputRef = useRef(null);

  const handleClickScan = async () => {
    // QRScannerView เลือกวิธีสแกนตามความสามารถของ browser เอง
    // ไม่ต้องไล่ลูกค้าออกไปเบราว์เซอร์ข้างนอกอีกแล้ว
    setIsOpen(true);
  };

  const _successScan = (detectedCodes) => {
    if (detectedCodes && detectedCodes.length > 0) {
      setIsOpen(false);
      onSuccessScan && onSuccessScan(detectedCodes[0].rawValue);
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;

    const value = await decodeQrFromImageFile(file);
    if (value) {
      onSuccessScan && onSuccessScan(value);
    } else {
      toast.error(t("Invalid QR code", { ns: "common" }));
    }
  };

  return (
    <ScanQRCodeStyled>
      <div className={customClass}>
        {!_isOpen ? (
          <>
            <div className="scan_qr_container" onClick={handleClickScan}>
              <div className="sq_block">
                <div className="sq_label">{label}</div>
                <Icons.Scan width={30} />
              </div>
            </div>
            {enableUpload && (
              <>
                <div className="or_divider">
                  <span className="or_line" />
                  <span className="or_text">{t("or", { ns: "common" })}</span>
                  <span className="or_line" />
                </div>
                <div
                  className="scan_qr_container upload_qr_container"
                  onClick={handleUploadClick}
                >
                <div className="sq_block">
                  <div className="sq_label">
                    {uploadLabel || t("Upload the QR code", { ns: "common" })}
                  </div>
                  <Icons.Upload width={24} />
                </div>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <QRScannerView
            onScan={_successScan}
            onClose={() => setIsOpen(false)}
          />
        )}
      </div>
    </ScanQRCodeStyled>
  );
};

ScanQRCode.propTypes = {};

export default ScanQRCode;
